// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Competition from "./competition.js"
import HighscoreGeneration from "./highscore-generation.js"
import HighscoreGenerationTeam from "./highscore-generation-team.js"
import Survey from "./survey.js"

const modelClassData = {
  "attributes": {
    "highscore_generation_id": {
      "column": {
        "default": null,
        "name": "highscore_generation_id",
        "null": false,
        "type": "uuid"
      },
      "name": "highscore_generation_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "HighscoreGenerationSurvey",
  "collectionKey": "highscore_generation_surveys",
  "collectionName": "highscore_generation_surveys",
  "i18nKey": "highscore_generation_survey",
  "camelizedLower": "highscoreGenerationSurvey",
  "name": "HighscoreGenerationSurvey",
  "nameDasherized": "highscore-generation-survey",
  "pluralName": "highscore_generation_surveys",
  "ransackable_associations": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "belongs_to",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "has_one",
      "resource_name": "Highscore",
      "through": "highscore_generation"
    },
    {
      "className": "HighscoreGeneration",
      "collectionName": "highscore_generations",
      "foreignKey": "highscore_generation_id",
      "name": "highscore_generation",
      "macro": "belongs_to",
      "resource_name": "HighscoreGeneration",
      "through": null
    },
    {
      "className": "HighscoreGenerationTeam",
      "collectionName": "highscore_generation_teams",
      "foreignKey": "highscore_generation_survey_id",
      "name": "highscore_generation_teams",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationTeam",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "competition_id",
      "column": {
        "default": null,
        "name": "competition_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "highscore_generation_id",
      "column": {
        "default": null,
        "name": "highscore_generation_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_competition_id",
      "column": {
        "default": null,
        "name": "old_competition_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_highscore_generation_id",
      "column": {
        "default": null,
        "name": "old_highscore_generation_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_survey_id",
      "column": {
        "default": null,
        "name": "old_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "belongs_to",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "HighscoreGeneration",
      "collectionName": "highscore_generations",
      "foreignKey": "highscore_generation_id",
      "name": "highscore_generation",
      "macro": "belongs_to",
      "resource_name": "HighscoreGeneration",
      "through": null
    },
    {
      "className": "HighscoreGenerationTeam",
      "collectionName": "highscore_generation_teams",
      "foreignKey": "highscore_generation_survey_id",
      "name": "highscore_generation_teams",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationTeam",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "highscore_generation_survey",
  "primaryKey": "id"
}

/** Frontend model for HighscoreGenerationSurvey. */
export default class HighscoreGenerationSurvey extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  highscoreGenerationId() {
    return this.readAttributeUnderscore("highscore_generation_id")
  }

  /** @returns {boolean} */
  hasHighscoreGenerationId() {
    const value = this.highscoreGenerationId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {import("./competition.js").default | null} */
  competition() {
    return this._readBelongsToReflection({modelClass: Competition, reflectionName: "competition"})
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  loadCompetition() {
    if (!("competitionId" in this)) throw new Error("Foreign key method wasn't defined: competitionId")

    const id = this.competitionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "competition",
        model: this,
        modelClass: Competition
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  ensureCompetitionLoaded() {
    return this.ensureAssociationLoaded("competition")
  }

  /** @returns {import("./highscore-generation.js").default | null} */
  highscoreGeneration() {
    return this._readBelongsToReflection({modelClass: HighscoreGeneration, reflectionName: "highscore_generation"})
  }

  /** @returns {Promise<import("./highscore-generation.js").default | null>} */
  loadHighscoreGeneration() {
    if (!("highscoreGenerationId" in this)) throw new Error("Foreign key method wasn't defined: highscoreGenerationId")

    const id = this.highscoreGenerationId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "highscore_generation",
        model: this,
        modelClass: HighscoreGeneration
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./highscore-generation.js").default | null>} */
  ensureHighscoreGenerationLoaded() {
    return this.ensureAssociationLoaded("highscore_generation")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./highscore-generation-team.js").default>} */
  highscoreGenerationTeams() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_generation_survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "highscore_generation_teams",
        model: this,
        modelClass: HighscoreGenerationTeam
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-generation-team.js").default>>} */
  loadHighscoreGenerationTeams() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_generation_survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "highscore_generation_teams",
        model: this,
        modelClass: HighscoreGenerationTeam
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-generation-team.js").default>>} */
  ensureHighscoreGenerationTeamsLoaded() {
    return this.ensureAssociationLoaded("highscore_generation_teams")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }
}
